export const VERIFY_STATUSES = {
    active: 'ACTIVE',
    approved: 'APPROVED',
    reviewing: 'REVIEWING',
}
